'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('./Stepper.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var steps = function (stepDetails, index, isSidebar) { return (React__default['default'].createElement("div", { className: isSidebar ? "Stepper__content_sidebar_box" : "Stepper__content_box", key: index },
    React__default['default'].createElement("div", { className: isSidebar ? "Stepper__content_sidebar_top_txt" : "Stepper__content_top_txt" }, stepDetails.title),
    React__default['default'].createElement("div", { className: isSidebar ? "Stepper__content_sidebar_bottom_txt" : "Stepper__content_bottom_txt" }, stepDetails.subtitle))); };
var Stepper = function (props) {
    var _a = props.isSidebar, isSidebar = _a === void 0 ? true : _a, stepperDetails = props.stepperDetails;
    return (React__default['default'].createElement("div", { className: "Stepper" },
        React__default['default'].createElement("div", { className: isSidebar ? "Stepper__order_sidebar" : "Stepper__order" },
            React__default['default'].createElement("div", { className: !isSidebar && "Stepper__circles" }, stepperDetails.map(function (step, index) {
                return React__default['default'].createElement(React__default['default'].Fragment, null,
                    React__default['default'].createElement("div", { className: "Stepper__circle" },
                        React__default['default'].createElement("div", { className: "Stepper__circle_inners" }, step.count)),
                    (index + 1) < stepperDetails.length &&
                        React__default['default'].createElement("div", { className: isSidebar ? "Stepper__line_sidebar" : "Stepper__line" }));
            })),
            React__default['default'].createElement("div", { className: isSidebar ? "Stepper__content_sidebar" : "Stepper__content" }, stepperDetails.map(function (step, index) { return steps(step, index, isSidebar); })))));
};

exports.Stepper = Stepper;
//# sourceMappingURL=Stepper.js.map
